import api from '@/api/api';

export const getMeUser = async () => {
  try {
    const response = await api.get('/user');
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.status);
  }
};
